"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialConfigState = void 0;
exports.initialConfigState = {
    requestId: '',
    asin: '',
    routing: {
        adgwdg: undefined
    }
};
